module.exports = __webpack_public_path__ + "static/bouddha_small-586cf768c5848aaa904fc139620bae46.jpg";